import { FormsService } from "../../../services/forms/forms.service";
import { ConfirmStripeAuthRequestActionType } from "../types";

export function* confirmStripeAuthSaga({ payload }: ConfirmStripeAuthRequestActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.updatePaymentStripeAuth(payload);

        if (data.stripe) {
            window.handleChange({ id: "payment.paymentMethod.stripe", value: true });
        }
    } catch (error) {
        console.log("confirmStripeAuthSaga Error", error);
        // yield put(Handle Error);
    }
}
